module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"color-picker\"> <div class=\"d-flex justify-content-between\"> <label>")
    ; __append(escapeFn( locals.label ))
    ; __append("</label> <div class=\"reset-color\"></div> </div> <div class=\"form-group\"> <div class=\"input-group\"> <span class=\"input-group-addon\"><div class=\"color-preview\"></div></span> <input type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn( locals.color ))
    ; __append("\" placeholder=\"")
    ; __append(escapeFn( locals.placeholder ))
    ; __append("\"> </div> <div class=\"scp-container\"></div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/brand/color_picker/template.ejs
// module id = 1299
// module chunks = 1